<template>
	<div>
		<flEditarVisualizar v-if="exibeStatus" :item="item" :editar="editar" @click-editar="(item) => $emit('click-editar', item)" />

		<div class="row" v-if="_existe(item.descricaoSubstituida)">
			<div class="col-md-12">
				<p style="color: red" v-if="item.descricaoSubstituida != null && item.descricaoSubstituida != ''">SUBSTÍTUIDA - NUMBER: {{item.descricaoSubstituida}}</p>
			</div>
		</div>

		<div class="row">

			<div class="col-md-6">
				<small v-if="exibeLegenda && _existe(item.c2)" style="color: #777">(Documentation Title)<br/></small>
				<p v-if="item.c2 != null && item.c2 != ''">{{item.c2}}</p>
			</div>


			<div class="col-md-3">
				<small v-if="exibeLegenda && _existe(item.c1)" style="color: #777">(Aplicable Documentation)<br/></small>
				<p v-if="item.c1 != null && item.c1 != ''">{{item.c1}}</p>
			</div>

			<div class="col-md-3">
				<small v-if="exibeLegenda && (_existe(item.refManual) || _existe(item.documentation))" style="color: #777">(Documentation)<br/></small>
				<p>{{item.refManual}} {{item.documentation}}</p>


			</div>
		</div>

		<!-- <div class="row">
			<div class="col-md-8">
				<p style="margin-top:10px"><small v-if="exibeLegenda" style="color: #777">(Description)<br/></small>{{item.description}}</p>
			</div>
		</div> -->

		<!-- <hr style="margin-bottom:0px" /> -->
	</div>
</template>

<script>
import flEditarVisualizar from './editar-visualizar.vue'
export default {

	components: {
		flEditarVisualizar
	},

	props: {
		item: {
			required: true,
			type: Object,
		},

		editar: {
			type: Boolean,
			required: false,
			default: true,
		},

		exibeLegenda: {
			required: true,
			type: Boolean,
		},

		exibeStatus: {
			type: Boolean,
			required: false,
			default: true,
		},
	}
}
</script>




// WEBPACK FOOTER //
// src/views/followair/manutencao/modelo/templates/AIRBUS_AMM.vue